import type { SdkWallet } from './wallets-context.js';

/**
 * External-wallet providers are device-local. Fail closed until the current
 * device proves that it has a matching connected provider.
 */
export function applyDeviceWalletAvailability(
  wallets: readonly SdkWallet[],
  connectedExternalAddresses: readonly string[],
): readonly SdkWallet[] {
  const connected = new Set(connectedExternalAddresses.map((address) => address.toLowerCase()));
  return wallets.map((wallet) =>
    wallet.type === 'external'
      ? { ...wallet, isAvailable: connected.has(wallet.address.toLowerCase()) }
      : wallet,
  );
}

export function resolveAvailableActiveWallet(
  wallets: readonly SdkWallet[],
  activeWalletId: string | null,
): SdkWallet | null {
  const availableWallets = wallets.filter(
    (wallet) => wallet.archivedAt === null && wallet.isAvailable,
  );
  return (
    availableWallets.find((wallet) => wallet.id === activeWalletId) ??
    availableWallets.find((wallet) => wallet.isPrimary) ??
    availableWallets[0] ??
    null
  );
}

export function persistResolvedActiveWalletSelection(
  wallets: readonly SdkWallet[],
  activeWalletId: string | null,
  persistActiveWalletId: (walletId: string | null) => void,
): string | null {
  const resolvedId = resolveAvailableActiveWallet(wallets, activeWalletId)?.id ?? null;
  if (resolvedId !== activeWalletId) persistActiveWalletId(resolvedId);
  return resolvedId;
}
